export const LogoutIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M8.13739 18V23H23.1374V1H8.13739V6" />
        <path d="M14.1374 12H2.13739" />
        <path d="M4.13739 8.5L1.13739 12L4.13739 15.5" />
      </g>
    </svg>
  );
};
